import { useMemo } from "react";
import apiClient from "src/api/axiosClient";
import {
  Application,
  ApplicationSettings,
  CreateAdminApplicationRequestData,
  GetAdminApplicationsParams,
  UpdateAdminApplicationRequestData,
} from "../types";

export function useApplicationsApi() {
  return useMemo(
    () => ({
      getApplicationSettingsByDomain: () => {
        return apiClient.get<ApplicationSettings>(`/settings`);
      },

      getAdminApplications: (params: GetAdminApplicationsParams) => {
        return apiClient.get<{ items: Application[]; count: number }>(`/applications`, { params });
      },

      getAdminApplication: (applicationId: string) => {
        return apiClient.get<Application>(`/applications/${applicationId}`);
      },

      createAdminApplication: (data: CreateAdminApplicationRequestData) => {
        return apiClient.post<Application>(`/applications`, data);
      },

      updateAdminApplication: (applicationId: string, data: UpdateAdminApplicationRequestData) => {
        return apiClient.put<void>(`applications/${applicationId}`, data);
      },
    }),
    []
  );
}
